import { sideEffect } from './sideEffect'

export * from './Collaborator'
export * from './errors'

sideEffect()
